// extracted by mini-css-extract-plugin
export var columnWrapper = "ErrorPage-module__columnWrapper___J80L5";
export var contentBox = "ErrorPage-module__contentBox___Q1ZVA";
export var contentColumn = "ErrorPage-module__contentColumn___9tkmp";
export var devOnlyTitle = "ErrorPage-module__devOnlyTitle___h8uyr";
export var errorPage = "ErrorPage-module__errorPage___qZsYf";
export var errorPageContainer = "ErrorPage-module__errorPageContainer___VF7Xo";
export var image = "ErrorPage-module__image___QcI0T";
export var supportButton = "ErrorPage-module__supportButton___N4PNN";